import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Address, isObjectEmpty } from 'clicklease-ui-elements';
import { BusinessInfoFormFeatureName } from './business-info-form.reducer';
import {
    BusinessInformationFormState,
    WritableBusinessInformation,
} from '../../interfaces/business-information';

const getBusinessInfoFormState = (
    state: BusinessInformationFormState
): BusinessInformationFormState => state;

const getBusinessInfoForm = ({
    data,
}: BusinessInformationFormState): WritableBusinessInformation => ({
    name: data.name,
    phone: data.phone,
    email: data.email,
    address: data.address,
});

const getBusinessInfoFormEmpty = ({
    data,
}: BusinessInformationFormState): boolean => isObjectEmpty(data);

const getBusinessInfoFormIsSubmitting = ({
    isSubmitting,
}: BusinessInformationFormState): boolean => isSubmitting;

const getBusinessInfoFormIsSubmittingError = ({
    isSubmittingError,
}: BusinessInformationFormState): boolean => isSubmittingError;

const getBusinessInfoFormIsLoading = ({
    loading,
}: BusinessInformationFormState): boolean => loading;

const getBusinessInfoFormName = ({
    data,
}: BusinessInformationFormState): string => data.name;

const getBusinessInfoFormPhone = ({
    data,
}: BusinessInformationFormState): string => data.phone;

const getBusinessInfoFormEmail = ({
    data,
}: BusinessInformationFormState): string => data.email;

const getBusinessInfoFormAddress = ({
    data,
}: BusinessInformationFormState): Address => data.address;

export const BusinessInfoFormFeatureSelector =
    createFeatureSelector<BusinessInformationFormState>(
        BusinessInfoFormFeatureName
    );

export const BusinessInfoFormStateSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormState
);

export const BusinessInfoFormSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoForm
);

export const BusinessInfoFormEmptySelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormEmpty
);

export const BusinessInfoFormIsSubmittingSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormIsSubmitting
);

export const BusinessInfoFormIsSubmittingErrorSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormIsSubmittingError
);

export const BusinessInfoFormIsLoadingSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormIsLoading
);

export const BusinessInfoFormNameSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormName
);

export const BusinessInfoFormPhoneSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormPhone
);

export const BusinessInfoFormEmailSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormEmail
);

export const BusinessInfoFormAddressSelector = createSelector(
    BusinessInfoFormFeatureSelector,
    getBusinessInfoFormAddress
);
